/* ELA TEILA 2026-09-11. Modelio eilute po nuotrauka - NAUJAS formatas.

   KODEL ATSKIRAS FAILAS: originalas yra assets/et-model-fit.js (16.7 KB, devyni
   nesusije blokai). Jo perrasyti per API negalima - rasymo kanalas kerpa ties ~5 KB,
   tad likusieji astuoni blokai butu prarasti. Todel cia tik PERRASOM ta viena eilute,
   kuria sukuria originalas.

   KAIP VEIKIA:
   1) Laukiam, kol originalas sukurs #et-fit-line ir irasys savo teksta
      ("Model: 10.2 in / 26 cm back, 7.1 in / 18 cm neck, 11.4 in / 29 cm chest.").
   2) Is to teksto issitraukiam sesis skaicius. Pagal nugaros ilgi coliais atpazistam,
      kuris suo nuotraukoje: 10.2 = juodas, 9.8 = baltas, 12.6 = ryzas.
   3) PATAISA: ryzo suns kaklas originale irasytas 18 cm. Teisinga reiksme 20 cm,
      coliais 7.9 (20 / 2.54 = 7.87). Taisom cia, nes et-model-fit.js neperrasomas.
   4) Dydis, kuri suo vilki:
        drabuziai   juodas S,  baltas S,  ryzas M
        antkakliai  juodas XS, baltas XS, ryzas S
      Antkaklis atpazistamas is JSON-LD kategorijos ("Standard Collars"). Kaspinai
      turi kategorija "Pet Bows & Ribbons", tad i si filtra nepatenka.
   5) Zodis "Regular" pridedamas TIK kai produktas turi Regular/Wide pasirinkima
      (tikrinam dydziu etiketes puslapyje). Megztiniams ir antkakliams jo nera.
   6) Surenkam teksta ir irasom per innerHTML (reikia <br>).

   FORMATAS - vienetai TIK prie pirmo matmens:
     Desktop (>=1000px), dvi eilutes:
       Model: S Regular
       Back 10.2 in / 26 cm · Neck 7.1 / 18 · Chest 11.4 / 29
     Mobile (<=999px), luzis po "26 cm":
       Model: S Regular · Back 10.2 in / 26 cm
       Neck 7.1 / 18 · Chest 11.4 / 29

   Lygiavimas i kaire - assets/custom-fit-line.css.

   LAUKIMAS PER setTimeout, NE requestAnimationFrame: rAF nesisuka, kai skirtukas
   nematomas (fone), tad su rAF eilute likdavo neperrasyta. Patikrinta.

   Originalas perpiesia eilute paspaudus ar perjungus nuotrauka, todel kabinames
   MutationObserver ant paties elemento. Originalo tekstas issaugomas data-et-src.
   Atsaukimas: istrinti <script> eilute is snippets/et-scroll-keep.liquid. */
(function () {
  var GARMENT = { '10.2': 'S', '9.8': 'S', '12.6': 'M' };
  var COLLAR  = { '10.2': 'XS', '9.8': 'XS', '12.6': 'S' };
  var NECK_FIX = { '12.6': { i: '7.9', cm: '20' } };

  var mq = window.matchMedia ? window.matchMedia('(max-width: 999px)') : null;
  function isMobile() { return mq ? mq.matches : (window.innerWidth <= 999); }

  function isCollar() {
    var s = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < s.length; i++) {
      try {
        var j = JSON.parse(s[i].textContent || '{}');
        var c = j.category || '';
        if (/collar/i.test(c) && !/bow/i.test(c)) return true;
      } catch (e) {}
    }
    return false;
  }

  function hasFit() {
    var sel = '.product__info .product-form__variants .block-swatch__item,'
            + '.product__info .product-form__variants option,'
            + '.product__info .product-form__variants .combo-box__option-item';
    var els = document.querySelectorAll(sel), t = '';
    for (var i = 0; i < els.length; i++) { t += ' ' + (els[i].textContent || ''); }
    return /\b(regular|wide)\b/i.test(t);
  }

  function build(src) {
    var n = src.match(/\d+(?:\.\d+)?/g);
    if (!n || n.length < 6) return null;
    var bi = n[0], bc = n[1], ni = n[2], nc = n[3], ci = n[4], cc = n[5];
    if (NECK_FIX[bi]) { ni = NECK_FIX[bi].i; nc = NECK_FIX[bi].cm; }
    var size = (isCollar() ? COLLAR : GARMENT)[bi] || '';
    if (size && hasFit()) { size += ' Regular'; }
    /* 2026-10-15 (Rita): dvi eilutes visur (telefone ir kompiuteryje), coliai IR cm:
         Wears: S Regular · Model’s measurements, in / cm:
         back 10.2 / 26 · neck 7.1 / 18 · chest 11.4 / 29
       Telefone (12px) 253 px ir 274 px - telpa nuo 320 px plocio. */
    var head = (size ? 'Wears: ' + size + ' · ' : '') + 'Model’s measurements, in / cm:';
    var meas = 'back ' + bi + ' / ' + bc + ' · neck ' + ni + ' / ' + nc + ' · chest ' + ci + ' / ' + cc;
    return head + '<br>' + meas;
  }

  var line = null;

  function render() {
    if (!line) return;
    var txt = line.textContent || '';
    if (/back/i.test(txt) && /neck/i.test(txt) && /chest/i.test(txt) && /,/.test(txt)) {
      line.setAttribute('data-et-src', txt);
    }
    var src = line.getAttribute('data-et-src');
    if (!src) return;
    var html = build(src);
    if (!html) return;
    if (line.innerHTML !== html) { line.innerHTML = html; }
  }

  var tries = 0;
  function attach() {
    line = document.getElementById('et-fit-line');
    if (!line) {
      if (++tries > 60) return;
      return setTimeout(attach, 100);
    }
    render();
    setTimeout(render, 400);
    new MutationObserver(render).observe(line, { childList: true, characterData: true, subtree: true });
    if (mq && mq.addEventListener) mq.addEventListener('change', render);
    window.addEventListener('resize', render);
  }

  if (document.readyState !== 'loading') setTimeout(attach, 0);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(attach, 0); });
})();
